import axios from "axios";
import { BASE_API, APPLICATION } from "../../constants";
import { toast } from "react-toastify";
import { formatOrdersData } from "../orders/FormatUserOrders";

export const fetchUserRecentOrders = async ({
  appContext,
  setAppContext,
  setUserOrders,
}) => {
  try {
    const response = await axios.get(
      `${BASE_API}api/User/GetUserMostRecentOrders/${appContext.userInfo.userID}`,
      {
        headers: {
          Authorization: `Bearer ${appContext.userInfo.token}`,
          Application: APPLICATION,
        },
      }
    );

    const orders = formatOrdersData(response.data);
    setUserOrders(orders);
  } catch (error) {
    if (error.response?.status === 401) {
      const newAppContext = {
        userInfo: null,
        cart: null,
        cartItems: null,
      };
      setAppContext(newAppContext);
      localStorage.setItem("appContext", JSON.stringify(newAppContext));
      toast.error("Your session has expired. Please login again.");
    } else {
      console.error("Failed to fetch user recent orders:", error);
    }
  }
};
